module.exports = __webpack_public_path__ + "img/grayCircle.05dd1e9a.png";